<template>
  <v-row dense>
    <v-col cols="1">
      <v-text-field
        v-model="actionQuantity"
        outlined
        dense
        hide-details
        label=""
        type="number"
        background-color="white"
        min="1"
        :disabled="visualization"
      />
    </v-col>

    <v-col cols="4">
      <v-select
        v-model="actionUnityId"
        outlined
        dense
        label="Periodicidade"
        :hide-details="errors.actionUnity === undefined"
        :error-messages="errors.actionUnity"
        :items="actionUnities"
        :item-text="(item) => `${item.action} ${actionQuantity} ${item.unity}`"
        item-value="id"
        background-color="white"
        :disabled="visualization"
      />
    </v-col>

    <v-col>
      <v-select
        v-model="frequencyId"
        outlined
        dense
        label="Intervalo"
        :items="prescriptionFrequencies"
        item-text="name"
        item-value="id"
        :hide-details="errors.frequency === undefined"
        :error-messages="errors.frequency"
        background-color="white"
        :disabled="visualization"
      />
    </v-col>

    <v-col>
      <v-select
        v-model="periodId"
        outlined
        dense
        clearable
        label="Quando"
        :items="prescriptionPeriods"
        item-text="name"
        item-value="id"
        :hide-details="errors.period === undefined"
        :error-messages="errors.period"
        background-color="white"
        :disabled="visualization"
      />
    </v-col>

    <v-col>
      <v-select
        v-model="howLongId"
        outlined
        dense
        label="Periodo"
        :items="prescriptionHowLongs"
        item-text="name"
        item-value="id"
        :hide-details="errors.howLong === undefined"
        :error-messages="errors.howLong"
        background-color="white"
        :disabled="visualization"
      />
    </v-col>

    <v-col cols="auto" v-if="!visualization">
      <v-btn icon @click="savePrescriptionItemAction" color="light-blue">
        <v-icon v-if="showDelete">eva-checkmark-outline</v-icon>
        <v-icon v-else>eva-plus-outline</v-icon>
      </v-btn>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            icon
            :attrs="attrs"
            v-on="on"
            v-if="showDelete"
            @click="deletePrescriptionItemAction"
          >
            <v-icon>eva-trash-outline</v-icon>
          </v-btn>
        </template>

        <span>
          Excluir
        </span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
  // import SAVE_PRESCRIPTION_ITEM_ACTION from "@/graphql/prescription/save_prescription_item_action.gql";
  // import DELETE_PRESCRIPTION_ITEM_ACTION from "@/graphql/prescription/delete_prescription_item_action.gql";

  export default {
    name: "PrescriptionFormItemAction",
    props: {
      actionUnities: Array,
      prescriptionItemAction: {
        type: Object,
        default: () => {
          return {
            medicine_presentation_action_id: "",
            prescription_frequency_id: "",
            prescription_how_long_id: "",
            prescription_period_id: null,
            presentation_action_quantity: 1,
          };
        },
      },
      prescriptionFrequencies: Array,
      prescriptionPeriods: Array,
      prescriptionHowLongs: Array,
      showDelete: {
        type: Boolean,
        default: false,
      },
      addAction: Function,
      removeAction: Function,
      visualization: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        errors: {},
      };
    },
    created() {
      this.loadAction();
    },
    mounted() {
      this.loadAction();
    },
    watch: {
      actionUnities() {
        this.loadAction();
      },
    },
    computed: {
      actionUnityId: {
        set(value) {
          this.prescriptionItemAction.medicine_presentation_action_id = value;
        },
        get() {
          return this.prescriptionItemAction.medicine_presentation_action_id;
        },
      },
      actionQuantity: {
        set(value) {
          this.prescriptionItemAction.presentation_action_quantity = value;
        },
        get() {
          return this.prescriptionItemAction.presentation_action_quantity;
        },
      },
      frequencyId: {
        set(value) {
          this.prescriptionItemAction.prescription_frequency_id = value;
        },
        get() {
          return this.prescriptionItemAction.prescription_frequency_id;
        },
      },
      periodId: {
        set(value) {
          this.prescriptionItemAction.prescription_period_id = value;
        },
        get() {
          return this.prescriptionItemAction.prescription_period_id;
        },
      },
      howLongId: {
        set(value) {
          this.prescriptionItemAction.prescription_how_long_id = value;
        },
        get() {
          return this.prescriptionItemAction.prescription_how_long_id;
        },
      },
    },
    methods: {
      loadAction() {
        if (!this.actionUnityId) {
          let actionUnity = this.lodash.first(this.actionUnities);

          if (actionUnity) {
            this.actionUnityId = actionUnity.id;
            this.actionQuantity = actionUnity.defaultQuantity;
          }
        }
      },
      validatePrescriptionItemAction() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        if (!this.actionUnityId) {
          this.errors.actionUnity = errorMsg;
        }
        if (!this.frequencyId) {
          this.errors.frequency = errorMsg;
        }
        if (!this.howLongId) {
          this.errors.howLong = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
      savePrescriptionItemAction() {
        if (!this.validatePrescriptionItemAction()) return;

        this.addAction(this.prescriptionItemAction);
      },
      deletePrescriptionItemAction() {
        if (confirm("Você realmente deseja deletar essa ação?")) {
          this.removeAction(this.prescriptionItemAction);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
